module.exports = __webpack_public_path__ + "img/turbo_on.000a0c1d.svg";